import { RequiredGenerationShareLinkCell } from "./RequiredGenerationShareLinkCell";

export function getZaehlpunktColumn() {
  return {
    accessorKey: "metering_or_market_location_display_name",
    header: "Zählpunkt",
    enableSorting: true,
    enableEditing: false,
    Cell: ({ row, renderedCellValue }) => (
      <RequiredGenerationShareLinkCell
        missingValueText="Zählpunkt auswählen"
        renderedCellValue={renderedCellValue}
        siteId={row.original.site_id}
        tooltip="Zu den Erzeugungsanteilen"
      />
    )
  };
}
